import React, { useEffect, useState, useRef } from "react";
import TextfieldInput from "../../Shared/TextField";
import TitlePage from "../../Shared/TitlePage";
import DateSelectionFuture from "../../Shared/DateSelection/DateSelectionFuture";
import DescriptionItem from "../../Shared/DescriptionItem";
import DropdownResources from "../../Shared/Dropdowns/DropdownResources";
import { dataService } from "../../../Services/data/data.service";
import { Grid2, Divider, Box, Tooltip } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TableDragResources from "../../Shared/Tables/TableDragResources";
import { Save, ChevronLeft, CircleHelp } from "lucide-react";
import Button from "../../Shared/Buttons/Button";

function CreatePage(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  var today = new Date();
  var nextMonth = new Date();
  nextMonth.setDate(nextMonth.getDate() + 30);
  const [FromDate, setFromDate] = useState(today);
  const [ToDate, setToDate] = useState(nextMonth);
  const [ResourceName, setResourceName] = useState("");
  const [selectedResource, setSelectedResource] = useState("");

  const [allCurrencies, setAllCurrencies] = useState([]);
  const [activeCurrency, setActiveCurrency] = useState({ symbol: "€" });

  const [CompanyName, setCompanyName] = useState("");
  const [CompanyId, setCompanyId] = useState(null);
  const [ProjectName, setProjectName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [resources, setResources] = useState([]);
  const [projectrows, setProjectRows] = useState([]);
  const GetUserId = props.Login.userid;
  const [types, setTypes] = useState([]);
  const [helperTextProjectName, setHelperTextProjectName] = useState(null);
  const [helperTextResourceDescription, setHelperTextResourceDescription] = useState(null);
  const [errorProjectName, setErrorProjectName] = useState(false);
  const [errorResourceDescription, setErrorResourceDescription] = useState(false);
  const [emptyDetails, setEmptyDetails] = useState(false);

  const [generalError, setGeneralError] = useState(null);

  // TableDragResources
  const tableDragResourcesRef = useRef();

  useEffect(() => {
    dataService.getAllActiveCompaniesByUserId(props.Login.userid).then((results) => {
      setCompanies(results);
    });
    dataService.getResources(GetUserId).then((results) => {
      setResources(results);
    });
    dataService.getTypes().then((results) => {
      setTypes(results.sort((a, b) => a.description.localeCompare(b.description)));
    });
    dataService.getAllCurrencies().then((results) => {
      setAllCurrencies(results);
    });
  }, [GetUserId, props.Login.userid]);

  useEffect(() => {
    if (projectrows.length > 0) {
      setEmptyDetails(false);
    }
  }, [projectrows]);

  const setProject = (event) => {
    setProjectName(event.target.value);
  };

  const setTheFromDate = (event) => {
    if (event !== FromDate) {
      setFromDate(event);
    }
  };

  const setTheToDate = (event) => {
    if (event !== ToDate) {
      setToDate(event);
    }
  };

  const setDates = (fromDate, toDate) => {
    setToDate(toDate);
    setFromDate(fromDate);
  };

  const setCompany = (event) => {
    // for every item in projectrows, set accountId to null - accounts are linked to company so they are not transferable
    if (projectrows.length > 0) {
      let tempProjectRows = projectrows.map((row) => ({
        ...row,
        edit: true,
        accountId: null,
      }));

      setProjectRows(tempProjectRows);
    }

    if (event.target.value) {
      if (companies.some((x) => x.name === event.target.value)) {
        let tempCompany = companies.find((x) => x.name === event.target.value);
        // set activeCurrency
        let tempCurrency = allCurrencies.find((x) => x.id === tempCompany.currencyId);
        setActiveCurrency(tempCurrency);
        setCompanyId(tempCompany.id);
        setCompanyName(event.target.value);
      }
    } else {
      setCompanyId(null);
      setCompanyName("");
    }
  };

  const setResource = (event, extra) => {
    if (event !== null && event.value !== undefined && resources.some((x) => x.id === event.value)) {
      var selectedResourceElement = resources.find((x) => x.id === event.value);
      setResourceName(selectedResourceElement.name);
      setSelectedResource(selectedResourceElement);
    } else if (event !== null && event !== undefined && event.target !== undefined && event.target !== null && event.target.value !== undefined) {
      setResourceName(event.target.value);
      setSelectedResource(null);
    } else {
      setSelectedResource(null);
      setResourceName("");
    }
  };

  const save = (newProjectrows) => {
    setProjectRows(newProjectrows);
  };

  const validateRows = async () => {
    if (tableDragResourcesRef.current) {
      try {
        const valid = await tableDragResourcesRef.current.validateAllRows();
        return valid;
      } catch (error) {
        return false; // Or handle as needed
      }
    }
  };

  const sendToApi = async () => {
    if (
      ProjectName === "" ||
      ResourceName === "" ||
      CompanyId === "" ||
      CompanyName === "" ||
      FromDate === "" ||
      ToDate === "" ||
      ResourceName === null ||
      FromDate === null ||
      ToDate === null ||
      !(await validateRows())
    ) {
      if (ProjectName === "") {
        setHelperTextProjectName("Please enter a project name.");
        setErrorProjectName(true);
      } else {
        setHelperTextProjectName(null);
        setErrorProjectName(false);
      }
      if (ResourceName === "" || ResourceName === null) {
        setHelperTextResourceDescription("Please select or enter a registration point.");
        setErrorResourceDescription(true);
      } else {
        setHelperTextResourceDescription(null);
        setErrorResourceDescription(false);
      }
    } else {
      setHelperTextResourceDescription(null);
      setErrorResourceDescription(false);
      setHelperTextProjectName(null);
      setErrorProjectName(false);
      setEmptyDetails(false);
      if (projectrows.length === 0) {
        setEmptyDetails(true);
      } else {
        let tempProjectDetailRows = projectrows.map((row) => ({
          ...row,
          edit: false,
        }));
        setProjectRows(tempProjectDetailRows);
        let i = 1;
        let projectQr;
        let projectDetails = projectrows.map((x) => ({
          description: x.description,
          typeId: x.type,
          type: x.type,
          sequence: i++,
          color: x.color,
          dataListId: x.dataListId,
          accountId: x.accountId,
          HasComment: x.comment,
          IsParent: x.isParent,
          IsApiParent: false,
          externalApiId: x.externalApiId,
          price: x.price === "" || x.price === undefined || x.price === null ? 0 : parseFloat(String(x.price).replace(",", ".")),
          isProfit: x.isProfit,
          valueTypeId: x.valueTypeId,
          priceBundleId: x.priceBundleId,
        }));
        var resourceId = 0;
        if (selectedResource !== null && selectedResource !== undefined) {
          resourceId = selectedResource.id;
        }
        dataService
          .createNewProject(props.Login.userid, ProjectName, ResourceName, resourceId, CompanyId, CompanyName, FromDate, ToDate, projectDetails)
          .then((result) => {
            if (result && result.success === true) {
              toast.success("Project was saved successfully", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
              projectQr = result.qrCode;
              var navigateTo = `/modifyproject/${projectQr}`;
              navigate(navigateTo, { state: { from: "/create" } });
            } else if (result && result.success === false) {
              setGeneralError(result.message);
            } else {
              toast.error("Something went wrong.", { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            }
          })
          .catch((error) => {
            if (error.status === 403) {
              setGeneralError("You do not have an active subscription. Please contact your administrator.");
            } else {
              setGeneralError("Something went wrong. Please try again.");
            }
          })
          .finally(() => {});
      }
    }
  };

  const renderBackButton = () => {
    var navigateText = "Back to project management";
    var navigateLink = "/projectreportoverview";
    if (location.state?.from !== undefined && location.state?.from !== null && location.state?.from !== "manage") {
      var string = location.state?.from;
      if (string.toLowerCase().includes("/taplr.app/")) {
        string = string.replace("/taplr.app/", "");
      }

      switch (true) {
        case string.toLowerCase().includes("projectreportoverview"):
          navigateText = "Back to project overview";
          navigateLink = "/" + string;
          break;
        case string === "/":
          navigateText = "Back to homepage";
          navigateLink = "/";
          break;
        case string.toLowerCase().includes("results"):
          navigateText = "Back to results";
          navigateLink = "/" + string;
          break;
        default:
          navigateText = "Back to project management";
          navigateLink = "/" + string;
          break;
      }
    }

    return (
      <button className={classes.backButton} onClick={() => navigate(navigateLink, { state: { from: "/create" } })}>
        <ChevronLeft className={classes.backButton__icon} />
        {navigateText}
      </button>
    );
  };

  return (
    <React.Fragment>
      <TitlePage Text="Create your project" backbutton={true} {...props} />
      <Box
        sx={{
          maxWidth: "90%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          marginRight: "auto",
          marginLeft: "auto",
          marginTop: "148px",
        }}
      >
        <div className={classes.header}>
          {renderBackButton()}

          <h1>Create your project</h1>
        </div>

        <Box className={classes.container}>
          {generalError && (
            <div className={classes.errorContainer}>
              <p className={classes.errorMessage}>{generalError}</p>
            </div>
          )}
          <Box className={classes.projectOptions}>
            <Box className={classes.projectOption}>
              <label className={classes.labelContainer__label}>Project name</label>
              <TextfieldInput
                value={ProjectName}
                action={setProject}
                label={ProjectName ? " " : "Project"}
                InputLabelProps={{ shrink: false }}
                helperText={helperTextProjectName}
                error={errorProjectName}
              />
            </Box>
            <Box className={classes.projectOption}>
              {/* <DescriptionItem Text="Company name" /> */}
              <label className={classes.labelContainer__label}>Company</label>
              {/* dropdown to select a company from companies and set it */}
              <select value={CompanyName} onChange={setCompany} className={classes.dropdown}>
                <option value="" disabled selected>
                  Select a company
                </option>
                {companies.map((company) => (
                  <option key={company.id} value={company.name}>
                    {company.name}
                  </option>
                ))}
              </select>

              {/* <DropdownCompanyAdd companies={companies} value={CompanyName} action={setCompany} action2={setNewCompanyFunction} helperText={helperTextCompany} error={errorCompany} /> */}
            </Box>
            <Box className={classes.projectOption}>
              <div className={classes.projectOption__labelContainer}>
                <label className={classes.labelContainer__label}>Registration point</label>
                <Tooltip disableInteractive title="A registration point could be 'Welding machine 1'. It describes the location where you are taking measurements">
                  <CircleHelp className={classes.labelContainer__help} />
                </Tooltip>
              </div>

              <DropdownResources
                resources={resources}
                value={ResourceName}
                action={setResource}
                helperText={helperTextResourceDescription}
                error={errorResourceDescription}
                selectedResource={selectedResource}
              />
            </Box>
          </Box>
          <Grid2 item xs={12} style={{ marginBottom: "-1rem" }}>
            <DescriptionItem Text="Active between:" />
            <DateSelectionFuture setDates={setDates} FromDate={FromDate} ToDate={ToDate} setTheFromDate={setTheFromDate} setTheToDate={setTheToDate} />
            <Divider style={{ marginBottom: "2rem", marginTop: "1rem" }}></Divider>
          </Grid2>
          <div className={classes.projectOptionsContainer}>
            {!CompanyId && (
              <div className={classes.notAccessibleContainer}>
                <div className={classes.notAccessibleCard}>
                  <p className={classes.notAccessibleCard__title}>Please select a company to continue creating the project</p>
                </div>
              </div>
            )}
            <Box style={{ border: emptyDetails && "solid 2px", borderColor: emptyDetails && "#d32f2f", borderRadius: emptyDetails && "5px", padding: "4px" }}>
              <Grid2 item xs={12} sm={12} md={12}>
                <TableDragResources
                  ref={tableDragResourcesRef}
                  {...props}
                  create={true}
                  types={types}
                  currency={activeCurrency}
                  rows={projectrows}
                  setRows={setProjectRows}
                  companyId={CompanyId}
                  makeSave={save}
                />
              </Grid2>
              {emptyDetails && (
                <p style={{ color: "#d32f2f", fontWeight: "400", fontSize: "0.75rem", fontFamily: "Roboto, Helvetica, Arial", letterSpacing: "0.03333em" }}>Please create at least one item.</p>
              )}
            </Box>
          </div>

          <Box className={classes.buttonContainer}>
            <Button startIcon={<Save />} onClick={sendToApi}>
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default CreatePage;
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    position: "relative",
    background: "#FFFFFF",
    borderRadius: "8px",
    padding: "1.5rem",
    maxWidth: "100%",
  },

  header: {
    width: "100%",
    height: "40px",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    marginBottom: "16px",
  },

  backButton: {
    position: "absolute",
    top: "129px",

    display: "flex",
    alignItems: "center",
    gap: "4px",

    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    color: "#0C0E29",
    opacity: ".8",

    border: "none",
    padding: "0px",

    transition: "opacity ease-in-out .1s",

    "&:hover": {
      opacity: "1",
      cursor: "pointer",
    },
  },

  backButton__icon: {
    height: "16px",
    width: "16px",

    strokeWidth: "1.4px",
  },

  qrButton: {
    backgroundColor: "#C3996B",
  },
  buttonContainer: {
    marginTop: "15px",
    display: "flex",
    alignItems: "center",
    float: "right",
  },
  dropdown: {
    width: "100%",
    height: "56px",
    borderRadius: "5px",
    border: "1px solid #d3d3d3d",
    padding: "0.5rem",

    fontSize: "16px",
  },

  projectOptions: {
    display: "flex",
    gap: "16px",
    [theme.breakpoints.up("sm")]: {
      flexWrap: "nowrap",
    },
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
    },
    marginBottom: "16px",
  },

  projectOption: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    [theme.breakpoints.up("sm")]: {
      width: "33%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  projectOption__labelContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  labelContainer__label: {
    fontSize: "16px",
    fontFamily: "Lato, sans-serif",

    color: "rgba(12, 14, 41, 0.8)",
  },

  labelContainer__help: {
    height: "16px",
    width: "16px",

    display: "block",

    color: "rgba(12, 14, 41, 0.8)",

    transition: "color ease-in 0.2s",

    "&:hover": {
      color: "rgba(12, 14, 41, 1)",
    },
  },

  primaryIconButton: {
    height: "40px",
    padding: "0 16px",
    paddingLeft: "8px",

    border: "none",
    borderRadius: "4px",

    fontSize: "16px",
    color: "white",
    backgroundColor: "#C3996B",

    display: "flex",
    gap: "8px",
    alignItems: "center",

    transition: "all 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#a77d4f",
      color: "white",
      cursor: "pointer",
    },
  },

  iconButton__icon: {
    height: "20px",
    width: "20px",

    display: "block",
  },

  projectOptionsContainer: {
    position: "relative",
  },

  notAccessibleContainer: {
    width: "100%",
    height: "100%",

    position: "absolute",
    left: "0px",
    top: "0px",
    zIndex: "998",

    backgroundColor: "rgba(255, 255, 255, 0.6)",
    backdropFilter: "blur(8px)", // Apply blur to background elements

    borderRadius: "8px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  notAccessibleCard: {
    maxWidth: "320px",
    boxSizing: "border-box",

    padding: "16px",

    display: "flex",
    flexDirection: "column",

    alignItems: "center",

    backgroundColor: "white",

    border: "1px solid #EDEDED",
    borderRadius: "8px",
  },

  notAccessibleCard__title: {
    fontFamily: "Lato, sans-serif",
    fontSize: "16px",
    color: "rgba(12, 14, 41, 1)",

    margin: "0px",
    marginBottom: "8px",
  },

  notAccessibleCard__subtitle: {
    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    color: "rgba(12, 14, 41, 0.8)",

    textAlign: "center",

    margin: "0px",
  },

  errorContainer: {
    width: "100%",
    backgroundColor: "#FDF3F3",

    border: "1px solid #FBE5E5",
    borderRadius: "6px",

    marginBottom: "16px",
    padding: "12px",
  },

  errorMessage: {
    fontSize: "16px",
    color: "#D84949",
  },
}));
